import { ReactNode } from 'react';

import { ServiceOutage } from './Errors/ServiceOutage';

import { GlobalErrorType, useErrorStore } from '@/store/ErrorStore';

/**
 * ErrorMessages component handles all error states in the application.
 * It checks for various error conditions and displays the appropriate error UI.
 * When an error is present, it renders the error component which takes over the full screen.
 * Returns null if no error conditions are met, allowing normal app flow.
 */
export const ErrorMessages = (): ReactNode => {
  const { globalError } = useErrorStore();

  // Map error types to components
  switch (globalError) {
    case GlobalErrorType.SERVICE_OUTAGE:
      return <ServiceOutage />;
    default:
      return null;
  }
};
